export default __webpack_public_path__ + "static/media/elevate-wht-3.b83ced1a.png";